document.addEventListener("DOMContentLoaded", () => {
  //////// MEGA_MENU DESKTOP /////////

  const sublinks = document.querySelectorAll(".ds-sublink");
  const subSublinksContainers = document.querySelectorAll(".ds-sub-sublinks");

  // Setze data-sublink-index für Sublinks und verstecke Sub-Submenüs
  sublinks.forEach((sublink, index) => {
    sublink.setAttribute("data-sublink-index", index);
    sublink.setAttribute("data-active", "false");

    const container = subSublinksContainers[index];
    if (container) {
      container.style.display = "none";
      container.setAttribute("data-active", "false");
      container.setAttribute("data-sublink-index", index);

      if (container.children.length > 0) {
        sublink.setAttribute("data-has-sublinks", "true");
      }
    }
  });

  sublinks.forEach((sublink) => {
    sublink.addEventListener("mouseenter", function () {
      const sublinkIndex = this.getAttribute("data-sublink-index");

      // Alle Sub-Sublinks ausblenden und data-active auf "false" setzen
      subSublinksContainers.forEach((container) => {
        container.style.display = "none";
        container.setAttribute("data-active", "false");
      });

      // Alle Sublinks data-active auf "false" setzen
      sublinks.forEach((link) => {
        link.setAttribute("data-active", "false");
      });

      // Die entsprechenden Sub-Sublinks anzeigen und data-active auf "true" setzen
      const targetSubSublinks = document.querySelector(
        `.ds-sub-sublinks[data-sublink-index="${sublinkIndex}"]`
      );
      if (targetSubSublinks) {
        targetSubSublinks.style.display = "flex";
        targetSubSublinks.setAttribute("data-active", "true");
      }

      // Setze data-active des gehoverten Sublinks auf "true"
      this.setAttribute("data-active", "true");
    });
  });

  // Optional: Füge einen mouseleave Event Listener zum Hauptmenü-Container hinzu
  const menuContainer = document.querySelector(".menu-container"); // Passe dies an deine Struktur an
  if (menuContainer) {
    menuContainer.addEventListener("mouseleave", () => {
      // Alle Sub-Sublinks ausblenden und data-active auf "false" setzen
      subSublinksContainers.forEach((container) => {
        container.style.display = "none";
        container.setAttribute("data-active", "false");
      });

      // Alle Sublinks data-active auf "false" setzen
      sublinks.forEach((link) => {
        link.setAttribute("data-active", "false");
      });
    });
  }

  //////// NAV_MENU MOBILE /////////
  const navLinks = document.querySelectorAll(".ds-nav-links");
  const mobileBreakpoint = 1350; // Definieren Sie hier Ihren Breakpoint

  function updateArrow(arrowWrapper, isActive) {
    const arrow = arrowWrapper.querySelector(".ds-nav-menu-arrow");
    // if (arrow) {
    //     if (isActive) {
    //         arrow.src = arrow.src.replace('arrow-black.svg', 'arrow-down-black.svg');
    //     } else {
    //         arrow.src = arrow.src.replace('arrow-down-black.svg', 'arrow-black.svg');
    //     }
    // }
  }

  function resetAllArrows() {
    document.querySelectorAll(".ds-nav-menu-arrow").forEach((arrow) => {
      updateArrow(arrow.closest(".ds-nav-button-wrapper"), false);
    });
  }

  function handleNavClick(event) {
    const clickedElement = event.target.closest(".ds-nav-button-wrapper");

    // Überprüfen, ob der geklickte Element der Wrapper ist
    if (!clickedElement) {
      // Wenn nicht der Wrapper geklickt wurde, lassen Sie den Link normal funktionieren
      return;
    }

    // Ab hier wissen wir, dass der Wrapper geklickt wurde
    event.preventDefault();

    const navLink = clickedElement.closest(".ds-nav-links");
    const navItem = clickedElement.closest(".ds-nav-links-item");
    const subNavItem = clickedElement.closest(".ds-nav-sublink-item");
    const subNav = clickedElement.closest(".ds-nav-sublink");

    // Behandlung von Hauptmenü-Klicks
    if (navItem) {
      const isCurrentlyActive = navLink.getAttribute("data-active") === "true";

      // Setzt alle data-active Attribute auf "false" und resettet alle Pfeile
      navLinks.forEach((l) => {
        l.setAttribute("data-active", "false");
      });
      resetAllArrows();

      // Toggle das aktuelle Menü und aktualisiere nur den geklickten Pfeil
      navLink.setAttribute("data-active", !isCurrentlyActive);
      updateArrow(clickedElement, !isCurrentlyActive);
      return;
    }

    // Behandlung von Submenü-Klicks
    if (subNavItem) {
      if (subNav && subNav.getAttribute("data-has-sublinks") === "true") {
        const isSubNavActive = subNav.getAttribute("data-active") === "true";

        // Schließe alle anderen aktiven Submenüs im gleichen Hauptmenü
        const parentNavLink = subNav.closest(".ds-nav-links");
        if (parentNavLink) {
          parentNavLink
            .querySelectorAll('.ds-nav-sublink[data-active="true"]')
            .forEach((activeSubNav) => {
              if (activeSubNav !== subNav) {
                activeSubNav.setAttribute("data-active", "false");
                updateArrow(
                  activeSubNav.querySelector(".ds-nav-button-wrapper"),
                  false
                );
              }
            });
        }

        // Toggle das aktuelle Submenü und aktualisiere nur den geklickten Pfeil
        subNav.setAttribute("data-active", !isSubNavActive);
        updateArrow(clickedElement, !isSubNavActive);
      }
      return;
    }
  }

  function setupMobileNav() {
    if (window.innerWidth <= mobileBreakpoint) {
      document.body.addEventListener("click", handleNavClick);
    } else {
      document.body.removeEventListener("click", handleNavClick);
      // Reset alle Pfeile und Menüzustände beim Wechsel zum Desktop-Modus
      resetAllArrows();
      navLinks.forEach((l) => l.setAttribute("data-active", "false"));
    }
  }

  // Initial setup
  setupMobileNav();

  // Überprüfen Sie die Bildschirmbreite bei jedem Resize-Event
  window.addEventListener("resize", setupMobileNav);

  //////// MERCHANT POPUP /////////

  const popupMerchant = document.getElementById("ds-popup-merchant");
  const closeButton = document.querySelector(".ds-popup-merchant-close");
  const overlay = document.getElementById("ds-overlay");
  const merchantLinks = document.querySelectorAll(".ds-merchant-link");

  function showPopupMerchant() {
    popupMerchant.style.display = "flex"; // Popup als flexbox anzeigen
    overlay.style.display = "block"; // Overlay anzeigen
  }

  function closePopupMerchant() {
    overlay.style.display = "none"; // Overlay verstecken
    popupMerchant.style.display = "none";
  }

  // Event Listener für alle Merchant-Links hinzufügen
  merchantLinks.forEach((link) => {
    link.addEventListener("click", showPopupMerchant);
  });

  closeButton.addEventListener("click", closePopupMerchant);

  window.addEventListener("click", function (event) {
    if (event.target == popupMerchant) {
      event.preventDefault();
      closePopupMerchant();
    }
  });

  // Event Listener für den Klick auf den Overlay
  overlay.addEventListener("click", closePopupMerchant);
});
